import { Component, OnInit, Input, ViewChild, ElementRef } from '@angular/core';
import { ValidatorFn,FormBuilder, FormGroup, FormArray, FormControl, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { NgxPermissionsService, NgxRolesService } from 'ngx-permissions';

//import constants
import { AppFrontRoutes } from '../../../../../constants/app-front-routes';

//import validators
import { ValidateExtension } from '../../../../../validators/extension.validator';

//import services
import { GeneralService } from '../../../../../services/general.service';
import { DeadlineService } from '../../../../../services/deadline.service';
import { MedicalService } from '../../../../../services/medical.service';
declare var $: any;

@Component({
  selector: 'app-medical-new-intervention',
  templateUrl: './medical-new-intervention.component.html',
  styleUrls: ['./medical-new-intervention.component.css']
})
export class MedicalNewInterventionComponent implements OnInit {

  @Input() ID: string;
  @Input() langs: string;
  @ViewChild('imagePreviewRef') imagePreviewRef: ElementRef;
  typePeriod: any;
  timeNotify: any;
  modalTitle: string;

  lang: any;
  record: any;
  mode: string;

  imageLink: any;
  
  createForm: FormGroup;
  createFormSubmitted: Boolean = false;
  createFormErrorMsg: any;
  occ_details: any;
  deadline_id: any;
  notification_time: any;
  rolepermission: any;
  records:any;
  id: number;
  employee:string
  datatableOptions:any;
  constructor(
    private route: ActivatedRoute,
    private formBuilder: FormBuilder,
    private generalService: GeneralService,
    private deadlineService: DeadlineService,
    private router: Router,
    public bsModalRef: BsModalRef,
    private modalService: BsModalService,
    private ngxRolesService: NgxRolesService,
    private medicalService: MedicalService
  ) { }

  ngOnInit() {

    this.datatableOptions = {
      paging: false,
      bAutoWidth: false,
      bSortClasses: false,
      searching:false
    }      
    
    var role = this.ngxRolesService.getRole('timetable');
    this.employee = AppFrontRoutes.EXAMINATION_VIEW
    this.rolepermission = '';
    if (role) {
      this.rolepermission = role.validationFunction[0];
    }

    this.FormBuild();
    this.getData();
  }

  FormBuild(): void {
    this.createForm = this.formBuilder.group({
      exam_date: ['', [Validators.required]],
      change_deadline: ['do_not_affect', [Validators.required]],
      exam_id: this.ID,
      intervention_id: "",
      action: 'update'
    });
  }

  onSubmit() {

    this.createFormSubmitted = true;

    console.log("===== Data submit =======")
    console.log(this.createForm)

    if (this.createForm.invalid)
      return;
    

    this.medicalService.updateOccurrence(this.createForm.value).subscribe(
      res => {

        if (res.status) {
          this.generalService.notify_msg('success', res.msg);
          this.bsModalRef.hide();
          
          this.router.navigateByUrl('/test', { skipLocationChange: true })
            .then(() => {
              this.router.navigate([this.employee+'/'+this.ID]);
          });
        }
        else {
          this.generalService.notify_msg('error', res.msg);
          this.bsModalRef.hide();
        }

      }
    );

  }


  formErrorClass(value, submitted): string {
    return value.errors && (value.touched || value.dirty || submitted) ? 'error-border' : '';
  }




  getData() {

    if (this.ID != "") {
      this.medicalService.newInterventionGet(this.ID)
        .subscribe(
          (res) => {
            console.log(res.data)
            this.lang = this.medicalService.GeneralGetLangData(res);
            console.log("========= Lang =========")
            console.log(this.lang)
            this.records     = res.data.employee
            this.deadline_id = res.data.deadline_id;
            this.occ_details = res.data.occ_details;
            this.notification_time = res.data.notification_time;
            this.ID = this.ID;
            this.modalTitle = this.lang.new_visit;
          }
        );
    }


  }

  
}
